import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";
import { toJS } from "mobx";
import { withAlert } from "react-alert";
import Layout from "../../components/Layout";
import moment from "moment";
import "moment/locale/ko";
import Timeline from "react-calendar-timeline";
// make sure you include the timeline stylesheet or the timeline will not be styled
import "react-calendar-timeline/lib/Timeline.css";
import user from "../../stores/userStore";
import corona from "../../stores/coronaStore";
import { Button, InputAdornment, TextField } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

const styles = theme => ({
  tableContainer: {
    marginTop: 20
  },
  view: {
    width: 1100,
    overflowX: "scroll"
  },
  btnView: {
    marginTop: 15
  },
  form: {
    width: 400
  }
});

var tempList = [
  { temp: "35.3" },
  { temp: "35.4" },
  { temp: "35.5" },
  { temp: "35.6" },
  { temp: "35.7" },
  { temp: "35.8" },
  { temp: "35.9" },
  { temp: "36.0" },
  { temp: "36.1" },
  { temp: "36.2" },
  { temp: "36.3" },
  { temp: "36.4" },
  { temp: "36.5" },
  { temp: "36.6" },
  { temp: "36.7" },
  { temp: "36.8" },
  { temp: "36.9" },
  { temp: "37.0" },
  { temp: "37.1" },
  { temp: "37.2" },
  { temp: "37.3" },
  { temp: "37.4" },
  { temp: "37.5" },
  { temp: "37.6" },
  { temp: "37.7" },
  { temp: "37.8" }
];

var keys = {
  groupIdKey: "index",
  groupTitleKey: "name",
  groupRightTitleKey: "rightTitle",
  itemIdKey: "id",
  itemTitleKey: "title",
  itemDivTitleKey: "title",
  itemGroupKey: "groupid",
  itemTimeStartKey: "start_time",
  itemTimeEndKey: "end_time",
  groupLabelKey: "name"
};
const groups = [
  {
    index: 1,
    name: "신정민"
  },
  {
    index: 2,
    name: "허정남"
  },
  {
    index: 3,
    name: "이창직"
  },
  {
    index: 4,
    name: "고승진"
  },
  {
    index: 5,
    name: "명준영"
  },
  {
    index: 6,
    name: "이현수"
  },
  {
    index: 7,
    name: "임현수"
  },
  {
    index: 8,
    name: "전승진"
  },
  {
    index: 9,
    name: "문성우"
  },
  {
    index: 10,
    name: "이수한"
  }
].sort(function (a, b) {
  return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
});

const View = observer(
  class Init extends React.Component {
    constructor(props) {
      super(props);
      this.state = { btnDelete: false };
    }

    componentDidMount = async () => {
      await user.getUserList();
      await corona.getList();
    };
    handleChange = e => {
      this.setState({
        [e.target.name]: e.target.value
      });
    };
    handleItemClick = itemId => {};
    handleDoubleClick = itemId => {};
    handleTempClcik = async (groupid, temp) => {
      try {
        this.setState({ btnDelete: true });
        await corona.addCorona(groupid, temp);
        this.setState({ btnDelete: false });
      } catch (e) {
        this.props.alert.show(e);
        this.setState({ btnDelete: false });
      }
    };
    handleDirectClcik = async groupid => {
      var temp = this.state.temp;
      try {
        this.setState({ btnDelete: true });
        if (temp) {
          await corona.addCorona(groupid, temp);
        } else {
          this.props.alert.show("텍스트를 입력해주세요. ex) 36.5");
        }

        this.setState({ btnDelete: false });
      } catch (e) {
        this.props.alert.show(e);
        this.setState({ btnDelete: false });
      }
    };

    render() {
      const { classes } = this.props;
      const USER = toJS(user.user);
      const groupid = groups.find(e => e.name == USER.username).index;
      const items = [];
      toJS(corona.list).map(item => {
        items.push({
          id: item.id,
          groupid: item.groupid,
          title: item.title,
          start_time: moment(item.start_time),
          end_time: moment(item.end_time)
        });
      });
      const groupLender = tempList.map(item => {
        return (
          <Button
            variant="contained"
            color="primary"
            className={classes.btn}
            style={{ margin: 10 }}
            onClick={() => this.handleTempClcik(groupid, item.temp)}
            disabled={this.state.btnDelete}
          >
            {item.temp}
          </Button>
        );
      });

      return (
        <Layout>
          <div className={classes.view}>
            <h2>코로나 열체크</h2>
            <TextField
              className={classes.form}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="temp"
              label="온도 직접입력(유효성 X)"
              type="text"
              id="temp"
              value={this.state.temp}
              onChange={this.handleChange}
              InputProps={{
                endAdornment: (
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.btn}
                    style={{ margin: 10 }}
                    disabled={this.state.btnDelete}
                    onClick={() => this.handleDirectClcik(groupid)}
                  >
                    등록
                  </Button>
                )
              }}
            />
            <div>{groupLender}</div>

            <Timeline
              keys={keys}
              canChangeGroup={false}
              canMove={false}
              canResize={false}
              groups={groups}
              items={items}
              defaultTimeStart={moment().add(-13, "day")}
              defaultTimeEnd={moment().add(13, "day")}
              onItemDoubleClick={this.handleDoubleClick}
              sidebarWidth={60}
            />
          </div>
        </Layout>
      );
    }
  }
);

const alertView = withAlert()(View);
export default withStyles(styles)(alertView);
